import { carouselItems } from '@/mocks/home';

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-10 md:py-14 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-1 h-6 bg-primary-500 rounded-full"></div>
          <h2 className="text-xl md:text-2xl font-bold text-foreground-900">焦点专题</h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6">
          {carouselItems.map((item) => (
            <div
              key={item.id}
              className="group relative bg-background-50 rounded-2xl border border-background-200/70 overflow-hidden hover:border-primary-200 transition-all duration-200 cursor-pointer flex flex-col sm:flex-row"
            >
              <div className="relative w-full sm:w-48 lg:w-56 flex-shrink-0 aspect-[16/10] sm:aspect-auto bg-background-200 overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="flex-1 p-4 md:p-5 flex flex-col justify-center">
                <span className="inline-flex self-start text-xs font-medium px-2.5 py-0.5 rounded-full bg-primary-100 text-primary-700 mb-2 whitespace-nowrap">
                  {item.category}
                </span>
                <h3 className="text-sm md:text-base font-bold text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-2 mb-2">
                  {item.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed line-clamp-3">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}